<mat-card appearance="outlined" telemetry="Card-ToDo-UtilityBilling">
    <mat-card-header>
        <mat-card-title>To Do</mat-card-title>
    </mat-card-header>

    <mat-card-content fxLayout="column">

        <div *ngIf="!hasItems" fxFlex fxLayoutAlign="center">
            You have no To Do Items
        </div>

        <ng-container *ngIf="hasItems">

            <div *ngFor="let item of displayItems" fxLayout="row" fxLayoutAlign="space-between center" class="row">

                <div fxFlex="30">
                    <a *ngIf="!isCustom(item)" (click)="openEntity(item)" [ngClass]="getClass(item)">
                        {{item.EntityNumber}}
                    </a>
                    <div *ngIf="isCustom(item)" [ngClass]="getClass(item)" class="padding">
                        {{item.EntityNumber}}
                    </div>
                </div>

                <div fxFlex="40" [ngClass]="pastDue(item)" class="description">
                    {{item.ItemDescription}}
                </div>

                <div fxFlex="20" [ngClass]="getClass(item)">
                    {{item.DueDate}}
                </div>

                <button mat-icon-button fxFlex="10" (click)="completed(item)" matTooltip="Complete"
                        [attr.aria-label]="getAriaLabel(item)" [attr.telemetry]="getAriaLabel(item)">
                    <mat-icon fontIcon="check_circle" fontSet="material-icons">done</mat-icon>
                </button>

                <mat-progress-bar [fxShow]="item.Saving" mode="indeterminate"></mat-progress-bar>
            </div>
        </ng-container>

        <div *ngIf="canShowMore">
            <mat-divider></mat-divider>

            <button mat-icon-button (click)="showMore($event)" class="fs32">
                <mat-icon fontIcon="more_horiz" fontSet="material-icons">
                </mat-icon>
            </button>
        </div>
    </mat-card-content>

    <mat-card-actions fxLayoutAlign="space-between start">
        <button *ngIf="canUndo" mat-button (click)="undo()" matTooltip="Undo" aria-label="Undo-ToDo-UtilityBilling">
            <mat-icon>undo</mat-icon>
        </button>

        <button mat-fab color="primary" (click)="addTodo()" matTooltip="Add To Do Item"
                telemetry="Submission-Add-ToDo-UtilityBilling">
            <mat-icon>add</mat-icon>
        </button>
    </mat-card-actions>
</mat-card>